module.exports = __webpack_public_path__ + "static/media/case_details_02.fad1c41a.jpg";